import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box, Card, CardContent, CardActionArea, Typography, Grid, Stack,
} from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

export default function Notifications() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios
      .get('https://portal.peaksoftcon.com:8081/api/notifications')
      .then((res) => setItems(res.data || []))
      .catch((err) => console.error('Error fetching notifications:', err));
  }, []);

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>Bildirimler</Typography>

      {items.length === 0 ? (
        <Stack alignItems="center" spacing={1} sx={{ py: 6 }}>
          <NotificationsActiveIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
          <Typography color="text.secondary">Henüz bildirim yok.</Typography>
        </Stack>
      ) : (
        <Grid container spacing={2}>
          {items.map((n, i) => {
            const card = (
              <Card sx={{ height: '100%' }}>
                {n.Notification_Url ? (
                  <CardActionArea
                    onClick={() => window.open(n.Notification_Url, '_blank')}
                    sx={{ height: '100%' }}
                  >
                    <CardContent>
                      <Typography variant="h6" sx={{ mb: 1 }}>{n.Notification_Name}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {n.Notification_Description}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                ) : (
                  <CardContent>
                    <Typography variant="h6" sx={{ mb: 1 }}>{n.Notification_Name}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      {n.Notification_Description}
                    </Typography>
                  </CardContent>
                )}
              </Card>
            );
            return (
              <Grid item xs={12} sm={6} md={4} key={i}>
                {card}
              </Grid>
            );
          })}
        </Grid>
      )}
    </Box>
  );
}
